import AdminLayout from "@/views/admin/AdminLayout.vue"
import Invoices from "@/views/admin/sales/InvoiceList.vue"
import InvoiceInfo from "@/views/admin/sales/InvoiceInfo.vue"
import InvoiceView from "@/views/admin/sales/InvoiceView.vue"
import InvoiceViewCustomer from "@/views/admin/sales/InvoiceViewCustomer.vue"
import InvoiceExport from "@/components/InvoiceViewPage"

const routes = [
  {
    path: "/:lang/share/invoices/:id",
    name: "SharedInvoiceView",
    component: InvoiceViewCustomer,
    meta: {
      title: "EstimatesAndInvoices.__ShareInvoice",
      requireAuth: false,
      back2Auth: false,
      auth: 0
    }
  },
  {
    path: "/:lang/invoices/export/:id",
    name: "InvoiceExport",
    component: InvoiceExport,
    props: route => ({
      ...route.params
    }),

    meta: {
      title: "ActionOption.__ExportPDF",
      requireAuth: false,
      back2Auth: false,
      auth: 0
    }
  },
  {
    path: "/:lang/invoices",
    component: AdminLayout,
    children: [
      {
        path: "",
        name: "Invoices",
        meta: {
          title: "EstimatesAndInvoices.__Invoice",
          requireAuth: true,
          auth: 0
        },
        component: Invoices,
        props: route => ({
          ...route.params
        })
      },
      {
        path: "new",
        name: "InvoiceNew",
        meta: {
          title: "EstimatesAndInvoices.__CreateInvoice",
          requireAuth: true,
          auth: 0
        },
        component: InvoiceInfo
      },
      {
        path: "edit/:id",
        name: "InvoiceEdit",
        meta: {
          title: "EstimatesAndInvoices.__EditInvoice",
          requireAuth: true,
          auth: 0
        },
        component: InvoiceInfo
      },
      {
        path: "customer-view/:id",
        name: "InvoiceCustomerView",
        meta: {
          title: "EstimatesAndInvoices.__PreviewAsCustomer",
          requireAuth: true,
          auth: 0
        },
        component: InvoiceViewCustomer
      },
      {
        path: ":id",
        name: "InvoiceView",
        meta: {
          title: "EstimatesAndInvoices.__Invoice",
          requireAuth: true,
          auth: 0
        },
        component: InvoiceView
      }
    ]
  }
]

export default routes
